import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	errorTitle: {
		id: 'business-list.list-view.labels-cell.error-title',
		defaultMessage: "We couldn't set the labels value",
		description: 'Error message informing the user that updating the labels field failed',
	},
	errorMessage: {
		id: 'business-list.list-view.labels-cell.error-message',
		defaultMessage: 'Check your connection, then give it another try.',
		description: 'Error message when save fails',
	},
	placeholder: {
		id: 'business-list.list-view.labels-cell.placeholder',
		defaultMessage: 'Select label',
		description: 'Placeholder text for label select component',
	},
	createNewItem: {
		id: 'business-list.list-view.labels-cell.create-new-item',
		defaultMessage: 'New label',
		description: 'Message to show when user is asked to create a new label',
	},
	noResults: {
		id: 'business-list.list-view.labels-cell.no-results',
		defaultMessage: 'No matches found',
		description: 'Message when no options are found in the labels select',
	},
	duplicate: {
		id: 'business-list.list-view.labels-cell.duplicate',
		defaultMessage: 'Label already added',
		description: 'Message when user searches for value they have already added in labels select',
	},
	labelMultipleOptionsLabel: {
		id: 'business-list.list-view.labels-cell.label-multiple-options-label',
		defaultMessage: 'Multiple labels can be selected',
		description:
			'Label informing the users that multiple label options can be selected under the label cell.',
	},
	selectBoxLabel: {
		id: 'business-list.list-view.labels-cell.select-box-label',
		defaultMessage: 'Label',
		description: 'Label of the combobox to select labels',
	},
});
